"use client";

import { useEffect } from "react";

/**
 * Client-side full-page redirect to /subscribe.
 *
 * The (app) layout uses this instead of Next.js's server-side redirect()
 * because redirect() during a soft navigation (router.push from another
 * route group) causes an infinite history.replaceState loop in the
 * client-side router, freezing the page.
 *
 * window.location.replace triggers a real browser navigation, which
 * completely avoids the client router state reconciliation issue.
 */
export default function SubscriptionRedirect() {
  useEffect(() => {
    window.location.replace("/subscribe");
  }, []);

  return null;
}
